export default __webpack_public_path__ + "static/media/profileIcon.32a143b3.svg";